<section class="section">
    <ng-content></ng-content>
</section>